import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import { Mortgage } from '../../dialer/model/model.mortgage';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})

export class ContactComponent {
	otherthem: boolean = false;
	@Input() data:any[];
	@Output() getContact: EventEmitter<Mortgage> = new EventEmitter();

	ngOnInit() {}

	close()
	{
		$('.right-sidebar').toggle();
	}

	changethem()	
	{
		this.otherthem = !this.otherthem;
	}

	onRowClick(data:any)
	{
		console.log("this rightsidebar component"+JSON.stringify(data));		
		this.getContact.emit(data);			
	}

}
